<template>
	<div class="text-white border-t border-purple-800 border-double">
		<div class="grid grid-cols-1 bg-purple-900/60 overflow-hidden">
			<div class="col-span-2">
				<ul class="flex flex-col">
					<li
						v-for="(subItem, index) in items"
						:key="`subMenuItem-${subItem.to.url}`"
						class="transition-all duration-700"
						:class="{
							'opacity-0': menuItemOpacity[index] === false,
							'opacity-100': menuItemOpacity[index] === true,
							'max-h-0': menuItemHeight[index] === false,
							'max-h-[10rem] py-2': menuItemHeight[index] === true,
						}"
					>
						<AtomLink
							v-bind="subItem.to"
							class="flex gap-6 py-3 px-6 border border-transparent rounded transition-colors"
							@click="emit('navigate')"
						>
							<AtomFontAwesome
								v-if="subItem.icon"
								class="size-6"
								:icon="subItem.icon"
							/>
							<AtomImage
								v-else-if="subItem.image"
								class="size-6"
								v-bind="subItem.image"
								:width="15"
								:height="15"
							/>
							<span class="flex flex-col gap-1">
								<span class="text-functional-size-sm font-bold">
									{{ subItem.text }}
								</span>
								<span
									class="text-functional-size-xs text-gray-300"
								>
									{{ subItem.description }}
								</span>
							</span>
						</AtomLink>
					</li>
				</ul>
			</div>
			<div
				v-if="banner"
				class="relative mx-4 rounded overflow-hidden transition-all duration-700"
				:class="{
					'max-h-0': !isBannerVisible,
					'min-h-[2rem] my-4': isBannerVisible,
				}"
			>
				<div class="absolute left-0 top-0 right-0 bottom-0">
					<AtomImage
						v-bind="banner.image"
						:height="590"
						:width="590"
						img-class="rounded object-cover"
					/>
				</div>
				<div class="absolute border border-purple-700 top-0 bottom-0 left-0 right-0 rounded bg-gradient-to-r from-purple-900 to-transparent" />
				<div class="relative p-4 flex flex-col gap-4 justify-between">
					<AtomTitle
						tag="h2"
						size="lg"
					>
						{{ banner.title }}
					</AtomTitle>
					<div>
						<AtomButton
							:variant="ButtonVariant.LightBorder"
							size="sm"
							:to="banner.to"
							:text="banner.buttonText"
							icon-right="fa-angle-right"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { SubMenuType } from '#base/core/types/MainMenuItemType';

const {
	items,
	banner,
	isOpen = false,
} = defineProps<SubMenuType & { isOpen?: boolean }>();

const emit = defineEmits(['navigate']);

const menuItemOpacity = reactive(items.map(() => false));
const menuItemHeight = reactive(items.map(() => false));
const isBannerVisible = ref<boolean>(false);

watch(() => isOpen, () => {
	menuItemOpacity.forEach((_item, index) => {
		const delay = isOpen ? index * 125 : (items.length - index) * 25;

		setTimeout(() => {
			menuItemOpacity[index] = isOpen;
		}, delay);
	});

	const menuItemHeightDelay = isOpen ? 0 : items.length * 25;

	menuItemOpacity.forEach((_item, index) => {
		setTimeout(() => {
			menuItemHeight[index] = isOpen;
		}, menuItemHeightDelay);
	});

	const bannerVisibilityDelay = isOpen ? items.length * 125 / 4 : 0;

	setTimeout(() => {
		isBannerVisible.value = isOpen;
	}, bannerVisibilityDelay);
});
</script>
